import React, { useMemo, createContext, useContext } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useMessagesPendingFeeAllocation } from "./ExpertPendingFeeAllocationHook";
// Set the default state values for each context
export const ExpertPendingFeeAllocationContext = /*#__PURE__*/createContext({});
export const ExpertPendingFeeAllocationContextProvider = ({
  children
}) => {
  const pendingContext = useMessagesPendingFeeAllocation();
  const pendingAllocationContext = useMemo(() => ({
    ...pendingContext
  }), [pendingContext.pendingFeeAllocation]);
  return /*#__PURE__*/React.createElement(ExpertPendingFeeAllocationContext.Provider, {
    value: pendingAllocationContext
  }, children);
};
export const useExpertPendingFeeAllocationContext = () => {
  return useContext(ExpertPendingFeeAllocationContext);
};
ExpertPendingFeeAllocationContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};